import { Component, inject, signal, OnInit } from '@angular/core';
import { FroalaEditorOptions } from '@r1-compass-library/models';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { FroalaEditorModule, FroalaViewModule } from 'angular-froala-wysiwyg';
import 'froala-editor/js/plugins.pkgd.min.js';
import { FroalaSetupService } from '../../services/froala-setup.service';

@Component({
    selector: 'r1-compass-app-froala-seperate-context',
    imports: [ReactiveFormsModule, FroalaEditorModule, FroalaViewModule],
    template: `
        <div class="editor-container">
            <div
                [froalaEditor]="froalaOptions"
                [formControl]="froalaContentFormControl()"
                [attr.data-role]="'drag-drop-target'"></div>
            <div class="hidden-editor"></div>
        </div>
        <b>{{ froalaOptions.key }}</b>
    `,
})
export class FroalaSeperateContextComponent implements OnInit {
    readonly #froalaSetupService = inject(FroalaSetupService);

    froalaOptions: FroalaEditorOptions = new FroalaEditorOptions();

    froalaContentFormControl = signal(new FormControl(''));

    constructor() {
        this.froalaOptions = this.#froalaSetupService.setupFroalaEditor();
        console.log(this.froalaOptions.key);
    }

    ngOnInit() {
        console.log(this.froalaOptions.key);
    }
}
